/** @module csi/table/matrix/ColumnEnum */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/enums",
	"csi/core/Key",
	"csi/xml",
	"./Path"
], function(declare, _, enums, Key, xml, PathMatrix) {

	return declare(PathMatrix, {
		/** @property {Boolean} - currently do not have functionality to filter in column matrix */
		restrictQuery: true,

		/** @property {Boolean} - whether or not to show a column for those nodes that have a blank enum value */
		showEmptyEnumValue: false,

		/** @property {Boolean} - whether or not to show columns for only those enums that are referenced by the data */
		showUsedEnumValues: false,

		/** @property {String} - id of the enum attribute used to identify to which column a node in the matrix belongs */
		//columnEnumId: null,

		/** @property {String} - name of the enum list holding values to display as columns */
		//columnEnumListName: null,

		/**
		 * @override
		 * If so configured, query for enum values that are used and only show them as columns rather than all enums 
		 */
		addDeferred: function(ctx, h, dfds) {
			if (this.showUsedEnumValues) {
				const view = ctx.view;
				const ql = view.getMainQueryLevel();
				const qr = view.getQueryResult();
				const store = ql.createStore(qr.getContext());

				if (store && store.getValuesStore) {
					const key = new Key({
						id: this.columnEnumId,
						path: h.getQueryPath()
					});
					const spec = ql.specBuilder.getSpecForKey(key);

					if (spec?.querySpec) {
						const valuesStore = store.getValuesStore(spec);
						this._cacheStore(ctx, h.matrixGroupId, valuesStore);
						dfds.push(valuesStore.query());
					}
				}
			}
		},

		/**
		 * Create client column nodes for enum values
		 * @param {Context} ctx
		 * @param {Heading} h
		 */
		_getColumnNodes: function(ctx, h) {
			const enumList = this.columnEnumListName;
			const emptyValue = xml.enumCreate(enumList);
			const valuesStore = ctx.view.getMatrixStore(h.matrixGroupId);
			var bRequired = !this.showEmptyEnumValue;
			var filterFunction;

			// if only showing used values, then create filter function that returns true only if value is used
			if (valuesStore) {
				const hash = {};

				valuesStore.query().forEach(function(item) {
					hash[valuesStore.getIdentity(item)] = 1;
				});

				if (hash[emptyValue]) {
					bRequired = false;
				}

				filterFunction = function(value, name, obj) {
					return hash[value];
				};
			}

			const enumStore = enums.getStore(enumList, null, filterFunction, bRequired);
			if (enumStore) {
				const idProperty = enumStore.idProperty;
				const labelProperty = enumStore.labelProperty;

				return enumStore.query().map(function(item) {
					var node = ctx.cache.createClientNode(null, null, item[labelProperty]);
					node.Value = item[idProperty];
					return node;
				});
			}

			return null;
		},

		/**
		 * Place nodes under the columns by applying a filter
		 */
		_filterNodes: function(ctx, spec, nodes) {
			var columnUrl = spec.columnUrl;
			var columnNode = ctx.cache.get(columnUrl);
			var id = this.columnEnumId;

			return _.filter(nodes, function(node) {
				return node[id] == columnNode.Value;
			});
		}
	});
});